import React, { useMemo, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { validateForm } from "utils/validation";
import { CandidateSelectionRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditCandidateSelectionForm from "./components/EditCandidateSelectionForm";
import fields from "../json/CandidateSelection.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

import {
    Update,
    GetById,
    GetAllCandidates,
    GetAllPositions
} from "adminApi/CandidateSelectionApi/CandidateSelection.js";

const EditCandidateSelection = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { formdata } = fields;

    //initialValues 
    const initialValues = useMemo(() => {
        return formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});
    }, [formdata]);

    //useFormChange
    const {
        values,
        errors,
        handleChange,
        setValues,
        setErrors
    } = useFormChange(
        initialValues,
        CandidateSelectionRules
    );

    // Fetch existing data
    const { loading: loadingFetch } = useFetchFormDataById(id, formdata, GetById, setValues);


    // Fetch Candidates
    const {
        data: CandidateOptions = []
    } = useFetchAllData(
        GetAllCandidates
    );

    // Fetch Positions
    const {
        data: PositionOptions = []
    } = useFetchAllData(
        GetAllPositions
    );

    // form submit
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            return await Update({ id, data: formValues });
        },
        (vals) => {
            const err = validateForm(vals, CandidateSelectionRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Candidate Selection Updated Successfully"
    )

    return (
        <>
            {(loadingSubmit || loadingFetch) && <Spinner isSpinner={true} />}
            <EditCandidateSelectionForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                CandidateOptions={CandidateOptions}
                PositionOptions={PositionOptions}
            />
        </>
    );
};

export default EditCandidateSelection;
